import { RecurrenciesVerificationParams } from "@/domain/dtos/params";
import { AppointmentReccurencyFrequency } from "@/domain/entities/Appointment";
import { z } from "zod";

export const RecurrenciesVerificationParamsSchema: z.ZodType<RecurrenciesVerificationParams> =
  z.object({
    interval: z.number().int().positive(),
    frequency: z.enum(AppointmentReccurencyFrequency),
    date: z.string(),
  });
